// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__nHtje","plus":"styles_plus__DtQGa","key":"styles_key__dG7iB"};